// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bairun-comment[data-v-69fc182c] .el-dialog .el-rate__icon{\n  font-size: 30px;\n}\n.bairun-comment[data-v-69fc182c] .el-dialog .el-select{\n  display: block;\n}\n", ""]);
// Exports
module.exports = exports;
